

import "../styles/base.scss";
import React, { MouseEventHandler, PropsWithChildren } from "react";
import logo from "./../assets/images/logo.png";
import { Link, Route, Router, withRouter } from "react-router-dom";
import { Footer } from "antd/lib/layout/layout";
import { FooterInfo } from "../models/system";
import { createBrowserHistory } from "history";
export class Header extends React.Component<PropsWithChildren<FooterInfo & { showad: boolean }>> {
    state = { key: "" }
    linkHandle: MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.currentTarget.parentElement?.querySelectorAll("a").forEach((item) => { item.classList.remove("choice") });
        e.currentTarget.className = e.currentTarget.className + " choice";
        return true;
    }
    virtuallinkHandle: MouseEventHandler<HTMLAnchorElement> = (e) => {

        //   window.alert("hi");
        window.open(this.props.virtualUrl, "_blank");
        return this.linkHandle(e);

    }

    private search() {

        let history = createBrowserHistory();

        history.push({
            pathname: "/views/search",
            state: {
                query: (document.getElementById("search") as HTMLInputElement).value
            }
        });
        history.go(0);
        // let key = (document.getElementById("search") as HTMLInputElement).value;
        // sessionStorage.setItem("search_key", key);

        // window.location.reload();

    }
    private menus: { name: string, path: string }[] = [
        { name: "首页", path: "/" },
        { name: "资讯", path: "/views/about" },
        { name: "展览", path: "/views/services" },
        { name: "馆藏", path: "/views/infos" },
        { name: "文创", path: "/views/contact" },
        { name: "活动", path: "/views/contact" },
        { name: "360虚拟博物馆", path: "/views/contact" },

    ];
    componentDidMount(): void {

        if (sessionStorage.getItem("search_key") !== undefined) {
            (document.getElementById("search") as HTMLInputElement).value = sessionStorage.getItem("search_key")!;
        }
        if (window.location.pathname.startsWith("/views/infos")) {
            document.getElementById("info")?.classList.add("choice");
        }
        else if (window.location.pathname.startsWith("/views/creates")) {
            document.getElementById("creates")?.classList.add("choice");
        }
        else if (window.location.pathname.startsWith("/views/services")) {
            document.getElementById("services")?.classList.add("choice");
        }
        else if (window.location.pathname.startsWith("/views/collects")) {
            document.getElementById("collects")?.classList.add("choice");
        }
        else if (window.location.pathname.startsWith("/views/shows")) {
            document.getElementById("shows")?.classList.add("choice");
        }
        else if (window.location.pathname.startsWith("/views/saving")) {
            document.getElementById("saving")?.classList.add("choice");
        }
        else {
            document.getElementById("home")?.classList.add("choice");
        }

    }
    render() {

        return (
            <header>
                <div className="header">
                    <nav>
                        <div className="logo">
                            <img alt="" className="logo" src={logo}></img>
                        </div>
                        <div className="main">
                            <Link to="/" id="home" onClick={this.linkHandle}>首页</Link>
                            <Link to="/views/infos/Oration" id="info" onClick={this.linkHandle}>资讯</Link>
                            <Link to="/views/shows/base" id="shows" onClick={this.linkHandle}>展览</Link>
                            <Link to="/views/saving" id="saving" onClick={this.linkHandle}>馆藏</Link>
                            <Link to="/views/creates" id="creates" onClick={this.linkHandle}>文创</Link>
                            <Link to="/views/services/education" id="services" onClick={this.linkHandle}>活动</Link>
                            <a onClick={this.virtuallinkHandle} href='#' id="virtual" className="is360" >360虚拟博物馆</a>
                        </div>
                        <div className={"search"} >
                            <input type="text" id="search" placeholder="请输入关键字"></input>
                            <div className="btnSearch" onClick={this.search} />
                        </div>

                        <div className="right">
                            <Link to="/views/search"></Link>
                            <Link to=""></Link>
                            <Link to={"/views/message"}></Link>
                            <Link to={"/views/contactus"}></Link>
                            <span className="language">
                                <Link to={""}>Eng</Link><span>|</span>
                                <Link to={""}>简体</Link><span></span>


                            </span>
                        </div>

                    </nav>
                    {
                        this.props.showad ?
                            <div className="header ad">
                                {
                                    this.props.adInfos?.map(x => <a href={x.url}><div><img src={x.pic} alt=""></img>
                                        <span>{x.title}</span>
                                    </div></a>)
                                }
                            </div> : null
                    }

                </div>
                {this.props.children}
            </header>
        );
    }
}
